import { gql } from './graphql';
function parsePreSigned(raw) {
    if (typeof raw === 'string')
        return JSON.parse(raw);
    return raw;
}
export async function uploadDocumentToDeal(dealID, contractName) {
    const data = await gql(`mutation UploadDocumentToDeal($dealID: String!, $contractName: String!) {
       uploadDocumentToDeal(dealID: $dealID, contractName: $contractName) {
         contract { contractID contractName }
         preSignedUploadData
       }
     }`, { dealID, contractName });
    const r = data.uploadDocumentToDeal;
    if (!r?.contract?.contractID || !r?.preSignedUploadData) {
        throw new Error('Backend did not return contract + preSignedUploadData');
    }
    return { contract: r.contract, preSignedUploadData: parsePreSigned(r.preSignedUploadData) };
}
// Standalone upload (no dealroom) — AI assigns the contract to a deal later.
// Mirrors dealroom-fe UploadContractDrawer's `uploadDocument` mutation path.
export async function uploadDocument(contractName) {
    const data = await gql(`mutation UploadDocument($contractName: String!) {
       uploadDocument(contractName: $contractName) {
         contract { contractID contractName }
         preSignedUploadData
       }
     }`, { contractName });
    const r = data.uploadDocument;
    if (!r?.contract?.contractID || !r?.preSignedUploadData) {
        throw new Error('Backend did not return contract + preSignedUploadData');
    }
    return { contract: r.contract, preSignedUploadData: parsePreSigned(r.preSignedUploadData) };
}
export async function setContractToImported(contractID) {
    await gql(`mutation SetContractToImported($contractID: String!) {
       setContractToImported(contractID: $contractID) { contractID }
     }`, { contractID });
}
async function sha1Base64(bytes) {
    const hash = await crypto.subtle.digest('SHA-1', bytes);
    const arr = new Uint8Array(hash);
    let bin = '';
    for (let i = 0; i < arr.length; i++)
        bin += String.fromCharCode(arr[i]);
    return btoa(bin);
}
// Mirrors dealroom-fe's preSignedFileUpload: multipart POST to S3 with SHA-1 checksum.
export async function preSignedFileUpload(preSigned, filename, contentType, bytes) {
    const fd = new FormData();
    Object.entries(preSigned.fields).forEach(([k, v]) => fd.append(k, v));
    fd.append('x-amz-checksum-sha1', await sha1Base64(bytes));
    fd.append('file', new Blob([bytes], { type: contentType }), filename);
    const res = await fetch(preSigned.url, { method: 'POST', body: fd });
    if (!res.ok) {
        throw new Error(`S3 upload failed (${res.status})`);
    }
}
